import React from 'react';
import { useWebLocale } from '../../contexts/WebLocaleContext';
import { ContentState, DiscoverySection } from '../../components/content/DiscoveryContent';
import ContentShelf from '../../components/responsive/ContentShelf';
import { safeExternalUrl } from '../ads/placement';
import EventCreative from './EventCreative';
import { useEvents, visibleEvents } from './useEvents';
import '../../styles/AppParity.css';
export function EventCard({ item, loopDuplicate = false }) {
  const { locale } = useWebLocale();
  const href = safeExternalUrl(item.destinationUrl);
  return href ? (
    <a
      aria-hidden={loopDuplicate || undefined}
      tabIndex={loopDuplicate ? -1 : undefined}
      className="pp-event-card"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={`${item.title || item.actionLabel} · ${locale === 'en' ? 'Opens in a new tab' : '새 탭에서 열기'}`}
    >
      <EventCreative item={item} />
    </a>
  ) : (
    <div className="pp-event-card" aria-hidden={loopDuplicate || undefined}>
      <EventCreative item={item} />
    </div>
  );
}
export function HomeEvents() {
  const { locale } = useWebLocale();
  const query = useEvents(true);
  const items = visibleEvents(query.data, true);
  if (query.isError || !items.length) return null;
  const title = locale === 'en' ? 'Events' : '이벤트';
  return (
    <DiscoverySection inlineMore title={title} to="/notice?category=event">
      <ContentShelf
        profile="features"
        className="pp-home-events"
        label={title}
        loop
        autoAdvanceMs={5000}
      >
        {items.map((item) => (
          <EventCard key={item.id} item={item} />
        ))}
      </ContentShelf>
    </DiscoverySection>
  );
}
export function EventList() {
  const { t } = useWebLocale();
  const query = useEvents();
  const items = visibleEvents(query.data);
  return (
    <ContentState query={query}>
      {items.length ? (
        <div className="pp-event-grid">
          {items.map((item) => (
            <EventCard key={item.id} item={item} />
          ))}
        </div>
      ) : (
        <p className="pp-secondary">{t('empty')}</p>
      )}
    </ContentState>
  );
}
